export const isStringNumeric = (str: string) => !Number.isNaN(str) && !Number.isNaN(parseFloat(str));
